import React from 'react';
import { Building2, DollarSign, ArrowUp, ArrowDown, Wallet } from 'lucide-react';
import { formatarMoeda } from '../contasPagar/utils/formatadores';

const CardsResumoRelatorios = ({ dados }) => {
  // Calcular totais
  const totalRegistros = dados.length;
  const totalSaldoInicial = dados.reduce((sum, item) => sum + (item.saldo_inicial || item.saldoInicial || 0), 0);
  const totalSaldo = dados.reduce((sum, item) => sum + (item.valorTotal || item.saldo || 0), 0);
  const totalEntrada = dados.reduce((sum, item) => sum + (item.entrada || item.valorPago || 0), 0);
  const totalSaida = dados.reduce((sum, item) => sum + Math.abs(item.saida || item.valorAberto || 0), 0);

  const cards = [
    {
      titulo: 'Contas Bancárias',
      valor: totalRegistros,
      icone: Building2,
      cor: {
        texto: 'text-[color:var(--report-blue-label)]',
        valor: 'text-[color:var(--report-blue-value)]',
        icone: 'text-[color:var(--report-blue-icon)]'
      }
    },
    {
      titulo: 'Saldo Inicial',
      valor: formatarMoeda(totalSaldoInicial),
      icone: Wallet,
      cor: {
        texto: 'text-[color:var(--report-cyan-label)]',
        valor: 'text-[color:var(--report-cyan-value)]',
        icone: 'text-[color:var(--report-cyan-icon)]'
      }
    },
    {
      titulo: 'Total Entrada',
      valor: formatarMoeda(totalEntrada),
      icone: ArrowUp,
      cor: {
        texto: 'text-[color:var(--report-green-label)]',
        valor: 'text-[color:var(--report-green-value)]',
        icone: 'text-[color:var(--report-green-icon)]'
      }
    },
    {
      titulo: 'Total Saída',
      valor: formatarMoeda(totalSaida),
      icone: ArrowDown,
      cor: {
        texto: 'text-[color:var(--report-red-label)]',
        valor: 'text-[color:var(--report-red-value)]',
        icone: 'text-[color:var(--report-red-icon)]'
      }
    },
    {
      titulo: 'Total Saldo',
      valor: formatarMoeda(totalSaldo),
      icone: DollarSign,
      cor: {
        texto: 'text-[color:var(--report-purple-label)]',
        valor: 'text-[color:var(--report-purple-value)]',
        icone: 'text-[color:var(--report-purple-icon)]'
      }
    }
  ];

  return (
    <div className="w-full">
      {/* Layout Mobile: 2 colunas para reduzir altura total */}
      <div className="grid grid-cols-2 gap-2.5 sm:hidden">
        {cards.map((card, index) => (
          <div
            key={index}
            className="bg-[color:var(--surface)] rounded-lg p-2.5 border border-[color:var(--border)] hover:bg-[color:var(--surface-muted)] transition-colors"
          >
            <div className="flex items-center gap-2.5">
              <card.icone className={`h-4 w-4 ${card.cor.icone} flex-shrink-0`} strokeWidth={1.5} />
              <div className="flex-1 min-w-0">
                <p className={`text-[10px] ${card.cor.texto} font-medium uppercase tracking-wide mb-0.5`}>
                  {card.titulo}
                </p>
                <p className={`text-sm font-semibold ${card.cor.valor} leading-tight`}>
                  {card.valor}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Layout Tablet: 2 colunas */}
      <div className="hidden sm:grid md:hidden grid-cols-2 gap-3">
        {cards.map((card, index) => (
          <div
            key={index}
            className="bg-[color:var(--surface)] rounded-lg p-3 border border-[color:var(--border)] hover:bg-[color:var(--surface-muted)] transition-colors"
          >
            <div className="flex flex-col h-full">
              <card.icone className={`h-5 w-5 ${card.cor.icone} mb-2`} strokeWidth={1.5} />
              <div className="flex-1">
                <p className={`text-[10px] ${card.cor.texto} font-medium uppercase tracking-wide mb-1`}>
                  {card.titulo}
                </p>
                <p className={`text-sm font-semibold ${card.cor.valor} leading-tight`}>
                  {card.valor}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Layout Desktop Médio: 3 colunas */}
      <div className="hidden md:grid lg:hidden grid-cols-3 gap-3">
        {cards.map((card, index) => (
          <div
            key={index}
            className="bg-[color:var(--surface)] rounded-lg p-3 border border-[color:var(--border)] hover:bg-[color:var(--surface-muted)] transition-colors"
          >
            <div className="flex flex-col h-full">
              <card.icone className={`h-5 w-5 ${card.cor.icone} mb-2`} strokeWidth={1.5} />
              <div className="flex-1">
                <p className={`text-[10px] ${card.cor.texto} font-medium uppercase tracking-wide mb-1`}>
                  {card.titulo}
                </p>
                <p className={`text-sm font-semibold ${card.cor.valor} leading-tight`}>
                  {card.valor}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Layout Desktop Grande: 5 colunas */}
      <div className="hidden lg:grid grid-cols-5 gap-3">
        {cards.map((card, index) => (
          <div
            key={index}
            className="bg-[color:var(--surface)] rounded-lg p-4 border border-[color:var(--border)] hover:bg-[color:var(--surface-muted)] transition-colors flex flex-col"
          >
            <div className="flex items-center justify-center mb-2">
              <card.icone className={`h-5 w-5 ${card.cor.icone}`} strokeWidth={1.5} />
            </div>
            <div className="flex-1 flex flex-col items-center text-center">
              <p className={`text-[10px] ${card.cor.texto} font-medium uppercase tracking-wide mb-1.5`}>
                {card.titulo}
              </p>
              <p className={`text-base font-semibold ${card.cor.valor} leading-tight`}>
                {card.valor}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CardsResumoRelatorios;
